export default {
  //更新当前打开的页签数组
  updateTagsList(state) {
    try {
      sessionStorage.tagsList = JSON.stringify(state.tagsList)
    } catch (e) {
    }
  },
  //清空页签数组
  clearTagsList(state) {
    try {
      state.tagsList = [
      ];
    } catch (e) {
    }
  },
	delKeepAlive(state,item){
		if(state.keepAlive.includes(item)){
			var currentTags = state.tagsList.filter((tagsListItem)=>{
				 return tagsListItem.name == item;
			});
			if(currentTags.length <2){
				state.keepAlive.splice(state.keepAlive.indexOf(item),1);
			}
		}
	},
  //项目id
  changeProjectId(state, ProjectId) {
    state.ProjectId = ProjectId

  },
  //工作流中tab标签
  gotoDetails(state, titleName) {
    state.titleName = titleName
  },
  //上传头像
  changePortrait(state, portraitPic){
    state.portraitPic = portraitPic
  },
	setKeepAlive: (state, keepAlive) => {
      state.keepAlive = keepAlive
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js